module.exports = require("!!vue-loader!../../../node_modules/vue-markdown-loader/lib/markdown-compiler.js?raw!./an-ode-to-the-number-40.md");


//////////////////
// WEBPACK FOOTER
// ./src/assets/posts/an-ode-to-the-number-40.md
// module id = 24
// module chunks = 7